import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { CoachAcquisitionPipeline } from "@/components/sales/coaches/CoachAcquisitionPipeline";
import { CoachProspectForm } from "@/components/sales/coaches/CoachProspectForm";
import { CoachAnalytics } from "@/components/sales/coaches/CoachAnalytics";
import { CoachSegmentation } from "@/components/sales/coaches/CoachSegmentation";
import { RetentionManagement } from "@/components/sales/coaches/RetentionManagement";

const CollegeCoaches: React.FC = () => {
  const [showNewProspectForm, setShowNewProspectForm] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-heading font-bold text-primary-700">College Coaches CRM</h1>
          <p className="text-gray-600">Manage coach acquisition, retention, and subscription growth</p>
        </div>
        <Button onClick={() => setShowNewProspectForm(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Add Coach Prospect
        </Button>
      </div>

      <CoachAnalytics />

      <Tabs defaultValue="pipeline" className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="pipeline">Acquisition Pipeline</TabsTrigger>
          <TabsTrigger value="segmentation">Coach Segmentation</TabsTrigger>
          <TabsTrigger value="retention">Retention & Growth</TabsTrigger>
          <TabsTrigger value="analytics">Advanced Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="pipeline" className="space-y-6">
          <CoachAcquisitionPipeline />
        </TabsContent>

        <TabsContent value="segmentation" className="space-y-6">
          <CoachSegmentation />
        </TabsContent>

        <TabsContent value="retention" className="space-y-6">
          <RetentionManagement />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Advanced Analytics Dashboard</CardTitle>
              <CardDescription>
                Detailed performance metrics and insights for coach acquisition and retention
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-center py-8 text-gray-500">
                Advanced analytics components coming soon...
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {showNewProspectForm && (
        <CoachProspectForm
          onClose={() => setShowNewProspectForm(false)}
          onSuccess={() => {
            setShowNewProspectForm(false);
            // Refresh data
          }}
        />
      )}
    </div>
  );
};

export default CollegeCoaches;